import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import * as Sentry from '@sentry/angular-ivy';
import {BaseServiceV1} from './base.service.v1';
import {Submission} from '@paperlessio/sdk/api/models';
import {Serializer} from '@paperlessio/sdk/api/serializers';

@Injectable({providedIn: 'root'})
export class SubmissionService extends BaseServiceV1<Submission> {
  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'submissions';
    this.serializer = new Serializer<Submission>(Submission);
  }

  cancelFormSubmission(submission_id: number): Observable<{}> {
    return this.http
      .post<{}>(`${this.BASE_URL + 'form_submission_cancellations'}`, {submission_id})
      .pipe(
        map(res => this.serializer.fromJson(res)),
        catchError(e => {
          Sentry.captureException(e);
          return throwError(e);
        }));
  }
}
